// Entegrasyon modülü mock verisi (backend gelene kadar). "MobiSupport sistemlerinizle konuşur."

export type IntegrationStatus = "connected" | "disconnected";

export interface ConfigField {
    key: string;
    label: string;
    type: "text" | "password" | "select";
    options?: string[];
    placeholder?: string;
}

export interface Integration {
    id: string;
    name: string;
    icon: string;
    category: string;
    phase: "V1" | "V2" | "V3";
    status: IntegrationStatus;
    desc: string;
    kind?: "apikeys";          // ozel UI (API anahtarlari yoneticisi)
    fields: ConfigField[];
}

export interface ApiKey { id: string; name: string; scope: "Read" | "Write" | "Admin"; token: string; }

export const MOCK_API_KEYS: ApiKey[] = [
    { id: "k1", name: "Portal Entegrasyonu", scope: "Read", token: "mobi_live_8f2a…d41c" },
    { id: "k2", name: "ERP Senkron", scope: "Write", token: "mobi_live_a17b…99fe" },
];

export const INTEGRATIONS: Integration[] = [
    // ── Otomasyon ──
    {
        id: "webhook", name: "Webhooklar", icon: "🔗", category: "Otomasyon", phase: "V1", status: "connected",
        desc: "Ticket olaylarında HTTP webhook tetikle.",
        fields: [
            { key: "url", label: "Webhook URL", type: "text", placeholder: "https://ornek.com/webhook" },
            { key: "secret", label: "Gizli Anahtar", type: "password", placeholder: "imza doğrulama" },
            { key: "event", label: "Olay", type: "select", options: ["Ticket Oluşturuldu", "Ticket Çözüldü", "Durum Değişti"] },
        ],
    },
    {
        id: "n8n", name: "n8n", icon: "⚙️", category: "Otomasyon", phase: "V1", status: "connected",
        desc: "Workflow post-action'larında n8n akışı çalıştır.",
        fields: [
            { key: "url", label: "n8n URL", type: "text", placeholder: "https://n8n.firma.com" },
            { key: "apiKey", label: "API Key", type: "password" },
        ],
    },
    // ── İletişim ──
    {
        id: "smtp", name: "SMTP / E-posta", icon: "✉️", category: "İletişim", phase: "V1", status: "connected",
        desc: "support@firma.com gelen kutusunu ticket'a çevir.",
        fields: [
            { key: "provider", label: "Sağlayıcı", type: "select", options: ["Özel SMTP", "Microsoft 365", "Google Workspace"] },
            { key: "server", label: "SMTP Server", type: "text", placeholder: "smtp.firma.com" },
            { key: "user", label: "SMTP User", type: "text", placeholder: "support@firma.com" },
            { key: "pass", label: "SMTP Password", type: "password" },
        ],
    },
    {
        id: "telegram", name: "Telegram", icon: "📨", category: "İletişim", phase: "V1", status: "disconnected",
        desc: "SLA ihlali / yeni ticket bildirimleri gönder.",
        fields: [
            { key: "token", label: "Bot Token", type: "password" },
            { key: "chatId", label: "Chat Id", type: "text", placeholder: "-100123456" },
        ],
    },
    {
        id: "teams", name: "Microsoft Teams", icon: "💬", category: "İletişim", phase: "V2", status: "disconnected",
        desc: "Yeni ticket'ları bir Teams kanalına düşür.",
        fields: [
            { key: "webhook", label: "Kanal Webhook URL", type: "text", placeholder: "https://outlook.office.com/webhook/…" },
            { key: "channel", label: "Kanal", type: "text", placeholder: "#support" },
        ],
    },
    {
        id: "whatsapp", name: "WhatsApp", icon: "🟢", category: "İletişim", phase: "V2", status: "disconnected",
        desc: "WhatsApp mesajından ticket oluştur.",
        fields: [
            { key: "phoneId", label: "Phone Number Id", type: "text" },
            { key: "token", label: "Access Token", type: "password" },
        ],
    },
    // ── Geliştirici ──
    {
        id: "api", name: "API Anahtarları", icon: "🔑", category: "Geliştirici", phase: "V1", status: "connected",
        desc: "Dış sistemler için API erişim anahtarları.",
        kind: "apikeys", fields: [],
    },
    // ── ERP ──
    {
        id: "logo", name: "Logo Tiger", icon: "🧾", category: "ERP", phase: "V3", status: "disconnected",
        desc: "Ticket kapanınca Logo'da servis fişi oluştur.",
        fields: [
            { key: "server", label: "Sunucu", type: "text" },
            { key: "db", label: "Veritabanı", type: "text" },
            { key: "user", label: "Kullanıcı", type: "text" },
            { key: "pass", label: "Şifre", type: "password" },
        ],
    },
    {
        id: "sap", name: "SAP", icon: "🟦", category: "ERP", phase: "V3", status: "disconnected",
        desc: "SAP ile servis/sipariş senkronu.",
        fields: [{ key: "host", label: "Host", type: "text" }, { key: "client", label: "Client", type: "text" }],
    },
    // ── CRM ──
    {
        id: "salesforce", name: "Salesforce", icon: "☁️", category: "CRM", phase: "V3", status: "disconnected",
        desc: "Salesforce case/aktivite senkronu.",
        fields: [{ key: "instance", label: "Instance URL", type: "text" }, { key: "token", label: "Access Token", type: "password" }],
    },
];

export const INTEGRATION_CATEGORIES = ["Otomasyon", "İletişim", "Geliştirici", "ERP", "CRM"];

// Mock log satirlari (Loglar modal'i icin).
export function mockLogs(name: string): { time: string; level: "ok" | "warn" | "err"; text: string }[] {
    return [
        { time: "10:42:18", level: "ok", text: `${name}: bağlantı testi başarılı` },
        { time: "10:41:02", level: "ok", text: `${name}: olay gönderildi (#10022)` },
        { time: "09:15:47", level: "warn", text: `${name}: yanıt gecikmeli (1240ms)` },
        { time: "08:03:11", level: "err", text: `${name}: zaman aşımı, yeniden denendi` },
    ];
}
